import { FloatingAiAssistant } from "@/components/ui/glowing-ai-chat-assistant";

export default function DemoOne() {
  return <FloatingAiAssistant />;
}
